import { restRequest } from 'common-src/features/rest/actions';
import { HttpMethods } from 'common-src/features/rest/constants';

export const getPatientScoreRequest = (query, params) =>
  restRequest({
    uri: 'patientScores',
    query,
    method: HttpMethods.Get,
    ...params,
  });
